import { Field } from 'react-final-form';
import { Box, FormField, FormHelp, Icon, Input, Label, Paragraph } from '@zillow/constellation-10';
import { IconWarningFilled } from '@zillow/constellation-icons';
import { FieldValidator, middleNameErrorText, middleNameRegex } from '../../../validation/validation';
import { MIDDLE_NAME } from '../../../constants/formFieldNames';

export default function MiddleNameField() {
  return (
    <Field
      name={MIDDLE_NAME}
      format={(middleName) => middleName?.trim()}
      formatOnBlur
      render={({ input, meta }) => {
        const { touched, active, error } = meta;
        const isInvalid = touched && !active && Boolean(error);

        return (
          <FormField
            error={isInvalid}
            label={<Label>Legal middle name</Label>}
            control={<Input {...input} />}
            description={
              isInvalid ? (
                <FormHelp>{error}</FormHelp>
              ) : !input?.value ? (
                <Box css={{ display: 'flex', marginTop: 'tightest' }}>
                  <Icon css={{ color: 'icon.feedback.warning.hero', marginRight: 'tighter' }}>
                    <IconWarningFilled />
                  </Icon>
                  <Paragraph textStyle="fineprint" css={{ color: 'text.feedback.warning.hero' }}>
                    This field is used to match to your identity. If you have a legal middle name, enter it to ensure
                    that an accurate credit & background report is returned.
                  </Paragraph>
                </Box>
              ) : null
            }
          />
        );
      }}
      validate={(middleName) => {
        const errors = new FieldValidator(middleName).maxLength(32).regex(middleNameRegex, middleNameErrorText).build();

        return errors ? errors : null;
      }}
    />
  );
}
